import services from '@/http';
import * as types from './mutations-types';

 const ActionProfileSetData = (Null, payload) => {
	return services.profile.profileSetData(payload).then(res => {
		return res.data.data
	})
}
 const ActionProfileGetData = ({commit}, payload) => {
	return services.profile.profileGetData(payload).then(res => {
		if(res.data.data != null){
            commit(types.SET_PROFILE,  res.data.data);
            
        }
        
        return res.data.data;
	})
}

 const ActionRevokeWispot = () => {
	return services.profile.revokeWispot().then(res => {								
		return res.data.data;
	});
}

export default {
	ActionProfileSetData,
	ActionProfileGetData,
	ActionRevokeWispot
}